import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Observer } from 'mobx-react';
import { toJS } from 'mobx';
import { useRootStore } from '../stores/BridgeProvider';
import { useSnackBars } from './SnackBarProvider';
import { COLORS } from '../components/util/Colors';
import permissionCheck from '../components/util/PermCheck';

const SetupAlert = () => {
  return (
    <Observer
      render={() => {
        const [loading, setLoading] = useState(true);
        const { orgStore, authStore } = useRootStore();
        const permitted = permissionCheck('ORG_M');
        const session = window.sessionStorage;

        const { setupTasks, settings } = orgStore;
        const { accountInfo } = authStore;
        const { NotificationPref, Name } = accountInfo;

        const { userNotified } = session;
        useEffect(() => {
          const initialize = async () => {
            await Promise.all([
              orgStore.retrieveChecklist(),
              authStore.retrieveUser(),
            ]);
            setLoading(false);
          };
          initialize();
        }, []);

        const updateUser = async () => {
          try {
            const modPref = [...toJS(NotificationPref)];
            const osIndex = NotificationPref.findIndex(
              p => p.Category === 'Organization Setup',
            );
            modPref[osIndex].Email = false;
            const pref = JSON.stringify(modPref);
            await authStore.request.post(
              `${process.env.REACT_APP_API}/api/user`,
              {
                name: Name,
                notificationPref: pref,
              },
            );
          } catch (err) {
            console.log(err);
          }
        };

        const triggerEmail = async () => {
          if (!orgStore.userNotified)
            try {
              const firstName = Name.split(' ')[0];
              await authStore.request.post(
                `${process.env.REACT_APP_API}/api/email-template`,
                {
                  subject: 'Organization Setup',
                  to: accountInfo.Email,
                  templateId: 'd-4d8815b54e444ea4a10b18e3dbfe33bb',
                  dynamicTemplateData: {
                    first_name: firstName,
                    org_name: settings.Name,
                    weblink: `${process.env.REACT_APP_DOMAIN}/onboarding/checklist`,
                  },
                },
              );
              orgStore.notifyUser();
            } catch (e) {
              console.log(e);
            }
        };

        const handleNotifications = () => {
          if (accountInfo.Email.length > 0) {
            const flatList = setupTasks.map(x => x.Items).flat();
            const everythingOk = flatList && flatList.every(item => item.IsOk);

            const preference = toJS(NotificationPref).filter(
              pref => pref.Category === 'Organization Setup',
            )[0];
            preference.Email &&
              !userNotified &&
              !everythingOk &&
              (triggerEmail(), updateUser());
          }
        };

        useEffect(() => {
          if (!loading && permitted) {
            handleNotifications();
            window.sessionStorage.setItem('userNotified', true);
          }
        }, [loading]);

        return null;
      }}
    />
  );
};

export default SetupAlert;
